<template>
  <div>
    <basic-container>
      <el-form :model="info" :rules="rules" ref="infoForm" label-width="120px">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="报单商家名称:">
                <span>{{ info.shopName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报单商家电话:">
                <span>{{ info.shopMobile }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="销售部门:">
                <span>{{ info.region }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="施工地址(区/县)">
                <span>{{ info.customAddress }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="渠道:">
                <span>{{ info.appointmentType }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户型:">
                <span>{{ info.houseType }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="业务员:">
                <span>{{ info.salesperson }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="进场时间:">
                <span>{{ info.entranceTime ? new Date(info.entranceTime).toLocaleDateString() : '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="付款人电话">
                <span>{{ info.customMobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款人姓名">
                <span>{{ info.customName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="工地联系人电话">
                <span>{{ info.contactMobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工地联系人姓名">
                <span>{{ info.contactName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="装饰公司:">
                <span>{{ info.introducer }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注:">
                <span>{{ info.remarks }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="附件备注:">
            <template v-if="formmaterImage(info.attachmentUrl).length">
              <!-- 图片文件：缩略图预览 -->
              <viewer v-if="formmaterImages(info.attachmentUrl).length" :images="formmaterImages(info.attachmentUrl)">
                <img v-for="src in formmaterImages(info.attachmentUrl)" :src="src" :key="src"
                  style="width: 80px; height: 80px; margin-right: 6px; object-fit: cover; cursor: pointer;" />
              </viewer>
              <!-- 非图片文件：支持下载 -->
              <span v-for="src in formmaterFiles(info.attachmentUrl)" :key="src" class="file-download"
                @click="downloadFile(src)">
                <i class="el-icon-document"></i>
                <span class="file-name">{{ getFileName(src) }}</span>
                <i class="el-icon-download"></i>
              </span>
            </template>
            <span v-else>-</span>
          </el-form-item>

          <el-form-item label="面积明细:">
            <el-table :data="info.areaConfig" style="width: 100%" border>
              <el-table-column prop="name" label="名称" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="length" label="长度(m)" width="300">
                <template slot-scope="scope">
                  <span>{{ scope.row.length }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="width" label="宽度(m)" width="300">
                <template slot-scope="scope">
                  <span>{{ scope.row.width }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="area" label="面积(㎡)" width="300">
                <template slot-scope="scope">
                  <span>{{ scope.row.area }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="productName" label="商品名称" width="300">
                <template slot-scope="scope">
                  <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item label="商品列表:">
            <el-table :data="selectedGoods" style="width: 100%" border>
              <el-table-column prop="goodsName" label="商品名称" />
              <el-table-column prop="num" label="数量" />
            </el-table>
          </el-form-item>
        </el-card>

        <div class="btn-group">
          <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        </div>
      </el-form>
    </basic-container>
  </div>
</template>

<script>
import {
  getMerchantOrder,
  editMerchantOrder,
  getAreaConfigById,
  getGoodList,
} from "@/api/work/ceiling/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
export default {
  data() {
    return {
      info: {
        region: "",
        customAddress: "",
        houseType: "",
        installationType: "",
        installationForm: "",
        remove: "",
        area: "",
        payType: "",
        measureTime: null,
        declarationDate: null,
        entranceTime: null,
        salesperson: "",
        customName: "",
        customMobile: "",
        remarks: "",
        introducer: "", // 装饰公司
        attachmentUrl: [],
      },
      selectedGoods: [],
      areaConfig: [], // 新增面积表格数据
      rules: {
        // region: [{ required: true, message: "请输入销售部门", trigger: "blur" }],
        appointmentType: [
          { required: true, message: "请输入渠道", trigger: "blur" },
        ],
        customAddress: [
          { required: true, message: "请输入施工地址(区/县)", trigger: "blur" },
        ],
        houseType: [{ required: true, message: "请输入户型", trigger: "blur" }],
        /* installationType: [
          { required: true, message: "请输入安装类型", trigger: "blur" },
        ],
        installationForm: [
          { required: true, message: "请输入安装形式", trigger: "blur" },
        ],
        remove: [
          { required: true, message: "请输入移除方式", trigger: "blur" },
        ],
        area: [{ required: true, message: "请输入面积", trigger: "blur" }],
        payType: [
          { required: true, message: "请输入付款方式", trigger: "blur" },
        ],
        measureTime: [
          { required: true, message: "请选择测量时间", trigger: "change" },
        ],
        declarationDate: [
          { required: true, message: "请选择报单日期", trigger: "change" },
        ], */
        entranceTime: [
          { required: true, message: "请选择进场时间", trigger: "change" },
        ],
        customName: [
          { required: true, message: "请输入付款人姓名", trigger: "blur" },
        ],
        customMobile: [
          { required: true, message: "请输入付款人手机号", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      // 获取基本信息
      getMerchantOrder(id).then((res) => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = {
            ...this.info,
            ...data,
          };
          this.info.attachmentUrl = data.attachmentUrl || [];
          // 当data.list存在时使用，否则调用getGoodList接口获取数据
          if (data.list && data.list.length > 0) {
            this.processSelectedGoods(data.list);
          } else {
            // 调用getGoodList接口获取商品数据
            getGoodList(id).then(res => {
              if (res.code === '200') {
                let selectedGoods = JSON.parse(res.data);
                //  合并相同goodsId的商品数量
                selectedGoods.forEach(goods => {
                  if (goods.goodsId) {
                    let existingGoods = this.selectedGoods.find(g => g.goodsId === goods.goodsId);
                    if (existingGoods) {
                      existingGoods.num += goods.num;
                    } else {
                      this.selectedGoods.push(goods);
                    }
                  }
                })
              }

            })
          }
          // 单独获取面积配置
          this.getAreaConfig();
        }
      });
    }
  },
  methods: {
    // 单独获取面积配置数据
    getAreaConfig() {
      const id = this.$route.query.id;
      if (id) {
        getAreaConfigById(id).then((res) => {
          if (res.code == "200") {
            const areaData = JSON.parse(res.data);
            // 确保 info.areaConfig 存在
            if (!this.info.areaConfig) {
              this.info.areaConfig = [];
            }
            // 更新面积配置数据
            this.info.areaConfig = areaData || [];
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    handleDateChange(value) {
      this.info.declarationDate = value ? new Date(value).getTime() : null;
    },
    handleEntranceTimeChange(value) {
      this.info.entranceTime = value ? new Date(value).getTime() : null;
    },
    // 处理商品列表并回显
    processSelectedGoods(selectedGoods) {
      const type = "HANG_CEILING";
      // 使用导入的API函数，避免与方法名冲突
      findPureWaterGoodsByRootDepartId(type).then((res) => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = this.transformToCascaderOptions(data);
            // 用于存储合并后的商品信息
            const mergedGoodsMap = new Map();
            // 确保selectedGoods是数组且不为空
            if (Array.isArray(selectedGoods) && selectedGoods.length > 0) {
              selectedGoods.forEach((g) => {
                // 先找到一级分类
                const parent = this.goodsList.find((item) =>
                  item.children.some((child) => child.value == g.goodsId)
                );
                if (!parent) return;
                // 找到二级分类
                const child = parent.children.find(
                  (child) => child.value == g.goodsId
                );
                const fullGoodsId = [parent.value, child.value];
                const fullName = parent.label + " / " + child.label;
                if (mergedGoodsMap.has(fullGoodsId.toString())) {
                  // 如果商品已存在，合并数量
                  const existingGoods = mergedGoodsMap.get(
                    fullGoodsId.toString()
                  );
                  existingGoods.num += g.num;
                } else {
                  // 如果商品不存在，添加新商品
                  mergedGoodsMap.set(fullGoodsId.toString(), {
                    goodsId: fullGoodsId,
                    num: g.num,
                    name: fullName,
                  });
                }
              });
            }
            // 更新选中的商品列表
            this.selectedGoods = Array.isArray(selectedGoods) ? Array.from(mergedGoodsMap.values()) : [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
    transformToCascaderOptions(data) {
      return data.map((item) => ({
        value: item.goodsId || "",
        label: item.goodsName || "",
        children: item.filters.map((filter) => ({
          value: filter.id || "",
          label: filter.value || "",
        })),
      }));
    },
    // 解析 attachmentUrl 字符串为图片 URL 数组
    formmaterImage(row) {
      const urls = [];
      if (!row) return urls;
      // 兼容数组形式与以逗号分隔的字符串
      if (Array.isArray(row)) {
        row.forEach((item) => {
          if (typeof item === "string") urls.push(item);
          else if (item && item.url) urls.push(item.url);
        });
      } else if (typeof row === "string" && row.length) {
        row.split(",").forEach((u) => u && urls.push(u));
      }
      return urls;
    },
    // 判断 URL 是否为图片文件
    isImage(url) {
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    // 提取附件中的图片 URL 数组
    formmaterImages(row) {
      return this.formmaterImage(row).filter((src) => this.isImage(src));
    },
    // 提取附件中的非图片文件 URL 数组
    formmaterFiles(row) {
      return this.formmaterImage(row).filter((src) => !this.isImage(src));
    },
    // 从 URL 中解析文件名
    getFileName(url) {
      if (!url) return "";
      const name = url.split("?")[0].split("/").pop();
      try {
        return decodeURIComponent(name || "附件");
      } catch (e) {
        return name || "附件";
      }
    },
    // 下载非图片附件
    // 优先 fetch 转 blob 通过 a[download] 强制下载（文件名可控）；
    // fetch 失败（如 OSS 未开启 CORS）时，对 OSS public 链接追加 response-content-disposition=attachment 强制下载，
    // 若带签名参数则回退为直接新窗口打开。
    downloadFile(fileUrl) {
      if (!fileUrl) return;
      const filename = this.getFileName(fileUrl);
      // 方式一：fetch 转 blob 直接下载
      fetch(fileUrl)
        .then((response) => {
          if (!response.ok) throw new Error("download failed");
          return response.blob();
        })
        .then((blob) => {
          const blobURL = window.URL.createObjectURL(blob);
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", filename);
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        })
        .catch(() => {
          // 方式二：OSS 链接追加 response-content-disposition=attachment 强制下载
          const isSignedUrl = /([?&])(OSSAccessKeyId|Signature|X-OSS-Process)=/.test(
            fileUrl
          );
          if (!isSignedUrl) {
            const separator = fileUrl.includes("?") ? "&" : "?";
            window.open(
              fileUrl + separator + "response-content-disposition=attachment",
              "_blank"
            );
          } else {
            // 签名 URL 无法追加参数（会破坏签名），退化为新窗口打开
            window.open(fileUrl, "_blank");
          }
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    // 添加面积项
    addAreaItem() {
      this.info.areaConfig.push({
        name: "",
        length: 0,
        width: 0,
        area: 0,
        declarationId: this.$route.query.id,
        sort: this.info.areaConfig.length + 1,
      });
    },
    // 删除面积项
    removeAreaItem(index) {
      this.info.areaConfig.splice(index, 1);
      // 重新排序
      this.info.areaConfig.forEach((item, i) => {
        item.sort = i + 1;
      });
    },
    // 计算面积
    calculateArea(row) {
      if (row.length && row.width) {
        row.area = Number((row.length * row.width).toFixed(2));
      } else {
        row.area = 0;
      }
    },
    // 在提交方法中处理面积数据
    submit() {
      const submitData = {
        ...this.info,
        areaConfig: this.info.areaConfig,
      };
      editMerchantOrder(submitData).then((res) => {
        if (res.code === "200") {
          this.$message.success("修改成功");
          this.goBack();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.card {
  margin-bottom: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-group {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
}

.file-download {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 6px;
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  cursor: pointer;
  color: #409eff;
  background: #f5f7fa;
  font-size: 13px;
  transition: all 0.2s ease;
}

.file-download:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

.file-download .file-name {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
